import { Card, CardActions, CardContent, CardMedia, Button, Typography,  Box, Chip,Tooltip } from '@mui/material';
import ImageBaseURL from 'utilities/api/axios';
import LikeButton from '../equipments/LikeButton';

const CardComponent = ({ item, setOpenDialog, searchQuery }) => {
  

  // Destructure data from the item prop
  const {
    name,
    category,
    location,
    description,
    availability,
    image,
  } = item;

  // Truncate description text
  const truncateText = (text, length) => {
    return text.length > length ? `${text.slice(0, length)}...` : text;
  };

  const descriptionLimit = 100;
  const truncatedDescription = truncateText(description || 'N/A', descriptionLimit);
  const filterData = (item) => {
    const query = searchQuery.toLowerCase();
    return (
      (name && name.toLowerCase().includes(query)) ||
      (category && category.toLowerCase().includes(query)) ||
      (location && location.toLowerCase().includes(query)) ||
      (availability && availability.toLowerCase().includes(query))
    );
  };

  const filtered = filterData(item);

  // Styles
  const cardStyles = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: { xs: '100%', sm: 'auto' },
    maxWidth: { xs: '100%', sm: 300 },
    padding: '.5rem',
    borderRadius: '1rem',
    border: '2px solid var(--Primary-Primary01, #edf1ff)',
    background: 'var(--Primary-Primary-11, #F4F4F4)',
    margin: { xs: '10px 0', sm: '10px 0px 0px 10px' },
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0px 12px 20px rgba(0, 0, 0, 0.3)',
    },
  };

  const mediaStyles = {
    height: { xs: 200, sm: 150 },
    borderRadius: '.75rem',
    border: '1px solid #7594ff',
    width: '100%',
  };

  const titleStyles = {
    color: '#5d6fb3',
    fontFamily: 'Inter',
    fontSize: { xs: '18px', sm: '22px' },
    fontWeight: '700',
    lineHeight: '1.35',
  };

  const infoStyles = {
    color: '#212121',
    fontFamily: 'Inter',
    fontSize: { xs: '14px', sm: '15px' },
    fontWeight: '350',
    lineHeight: '1.5',
  };

  const infoMarker = {
    fontWeight: '700',
  };

  // Function to get availability tag color based on status
  const getAvailabilityColor = (availStatus) => {
    const status = availStatus ? availStatus.toLowerCase() : '';
    if (status === 'always') {
      return { backgroundColor: '#4CAF50', color: '#fff' }; // Green
    } else if (status === 'high' || status === 'available') {
      return { backgroundColor: '#8BC34A', color: '#fff' }; // Light Green
    } else if (status === 'moderate') {
      return { backgroundColor: '#FFB84D', color: '#fff' }; // Orange
    } else if (status === 'low') {
      return { backgroundColor: '#FF9800', color: '#fff' }; // Dark Orange
    } else if (status === 'very low') {
      return { backgroundColor: '#F44336', color: '#fff' }; // Red
    }
    return { backgroundColor: '#FFB84D', color: '#fff' }; // Default Orange
  };

  const buttonStyles = {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.5rem',
    border: '2px solid var(--s-primary-source, #273F77)',
    letterSpacing: '0rem',
    fontWeight: '700',
    fontSize: '1rem',
    color: '#273F77',
    '&:hover': {
      backgroundColor: '#E79A2B',
    },
  };

  return (
    <>
      {filtered && (
        <Card sx={cardStyles}>
          <Box sx={{ position: 'relative' }}>
            <CardMedia
              sx={mediaStyles}
              image={image ? `${ImageBaseURL.defaults.baseURL}${image}` : './machine.png'}
              title={name}
            />
            <Box sx={{ position: 'absolute', top: '8px', right: '8px' }}>
              <LikeButton />
            </Box>
          </Box>
          <CardContent sx={{ padding: '10px 0px 10px 0px' }}>
            <Typography variant="h5" sx={titleStyles}>
              {name}
            </Typography>
            <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center', mb: '12px', flexWrap: 'wrap' }}>
              <Chip
                label={category || 'N/A'}
                sx={{
                  backgroundColor: '#E8F0FF',
                  color: '#5D6FB3',
                  fontWeight: '600',
                  fontSize: '13px',
                  height: '28px',
                  borderRadius: '12px',
                }}
                variant="outlined"
              />
              <Chip
                label={availability || 'N/A'}
                sx={{
                  ...getAvailabilityColor(availability),
                  fontWeight: '600',
                  fontSize: '13px',
                  height: '28px',
                  borderRadius: '12px',
                  border: 'none',
                }}
              />
            </Box>
            <Typography variant="body1" sx={infoStyles}>
              <span style={infoMarker}>Location:</span> {location || 'N/A'}
            </Typography>
          <Typography variant="body1" sx={infoStyles}>
            {description ? (
          <Tooltip
            title={
              <Box
                sx={{
                  maxWidth: 320,
                  p: 2,
                  bgcolor: '#f5f5f5', 
                 color: '#212121',
                  boxShadow: '0px 8px 20px rgba(0,0,0,0.15)',
                  borderRadius: '10px',
                  fontSize: '15px',
                  lineHeight: 1.6,
                }}
              >
                {description}
              </Box>
            }
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: 'transparent', 
                  p: 0,
                },
              },
              arrow: {
                sx: {
                  color: '#f5f5f5', 
                },
              },
            }}
          >
            <span style={{ cursor: 'pointer' }}>
              <span style={infoMarker}>Description:</span>{' '}
              {truncatedDescription}
            </span>
          </Tooltip>
            ) : (
              <>
                <span style={infoMarker}>Description:</span> N/A
              </>
            )}
          </Typography>
          </CardContent>
          <hr style={{ margin: '0px', height: '1.5px', backgroundColor: '#a0a0a0', opacity: '0.3' }} />
          <CardActions sx={{ padding: '10px 0px 10px 0px' }}>
            <Button onClick={setOpenDialog} size="small" sx={buttonStyles}>
              Book Machine
            </Button>
          </CardActions>
        </Card>
      )}
    </>
  );
};

export default CardComponent;
